import React, { memo } from 'react';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import { usePost } from '@src/store/posts/hooks/usePost';
import { useTranslation } from 'react-i18next';
import { PostStatus } from '@creator/sdk/modules/upvote/upvote.model';
import AlertBox from '@src/basic-components/AlertBox/AlertBox';
import { convertFirebaseTimestampToDate } from '@creator/ui/utils/date-utils';

interface PostStatusIndicatorProps {
    postId: string;
    tokenName: string;
}

const PostStatusIndicator: React.FC<PostStatusIndicatorProps> = props => {
    const { postId } = props;
    const post = usePost(postId);
    const { t } = useTranslation();

    if (!post) return null;
    if (post.status === PostStatus.PUBLISHED || post.status === PostStatus.PUBLISHED_UNLISTED) return null;

    function getScheduledAtText(): string {
        if (!post || !post.scheduledAt) return '';
        return convertFirebaseTimestampToDate(post.scheduledAt).toUTCString()
    }

    function getText(): string {
        if (!post) return '';
        return `${t(`postStatusIndicator.status${post.status}`, { scheduledAt: getScheduledAtText() })}`;
    }

    return (
        <AlertBox type="warning" className="border-none">
            <span className="">{getText()}</span>
        </AlertBox>
    );
};

export default memo(PostStatusIndicator, propsEqualityFn);
